import { Shadows } from '@mui/material/styles';

const FLAT = '0px 1px 2px 0px rgba(0, 0, 0, 0.05)';
const RAISED = '0px 4px 12px 0px rgba(0, 0, 0, 0.10)';
const FLOATING = '0px 8px 24px 0px rgba(0, 0, 0, 0.14)';
const OVERLAY = '0px 12px 40px 0px rgba(0, 0, 0, 0.18)';

const shadows: Shadows = [
  'none',
  FLAT, // Paper, Card, Accordion
  FLAT,
  FLAT,
  FLAT, // AppBar
  RAISED,
  RAISED,
  RAISED,
  RAISED, // Popover, Menu, Select
  FLOATING,
  FLOATING,
  FLOATING,
  FLOATING,
  FLOATING,
  FLOATING,
  FLOATING,
  FLOATING, // Drawer
  OVERLAY,
  OVERLAY,
  OVERLAY,
  OVERLAY,
  OVERLAY,
  OVERLAY,
  OVERLAY,
  OVERLAY, // Dialog
];

export default shadows;

export const FLAT_ELEVATION = 1;
export const RAISED_ELEVATION = 5;
export const FLOATING_ELEVATION = 9;
export const OVERLAY_ELEVATION = 17;
